import { Trash2 } from "lucide-react";

import { Button } from "@/shared/ui/button";
import { Card, CardContent } from "@/shared/ui/card";

export function ScheduleDeleteDialog({
  title,
  description,
  serverBusy,
  pending = serverBusy,
  unknown = false,
  onCancel,
  onDelete,
  onRetryUnknown,
}: {
  title: string;
  description: string;
  serverBusy: boolean;
  pending?: boolean;
  unknown?: boolean;
  onCancel: () => void;
  onDelete: () => void;
  onRetryUnknown?: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <Card className="w-full max-w-sm">
        <CardContent className="grid gap-3 pt-4">
          <h2 className="m-0 text-lg font-bold">{title}</h2>
          <p className="m-0 text-sm text-foreground-muted">{description}</p>
          <div className="flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={pending && !unknown}
            >
              {unknown ? "CLOSE" : "KEEP"}
            </Button>
            {unknown ? (
              <Button type="button" onClick={onRetryUnknown}>
                RETRY CHECK
              </Button>
            ) : (
              <Button
                type="button"
                variant="destructive"
                pending={pending}
                pendingLabel="DELETING…"
                onClick={onDelete}
              >
                <Trash2 aria-hidden="true" /> DELETE
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
